import HttpClient from '@/common/http'

export default {
  /**
   * @param {IdType} [parentId=0]
   * @param {string} [name='']
   * @param {CancelToken} [cancelTokenSource=null]
   * @returns {Promise}
   */
  Select (parentId = 0, name = '', cancelTokenSource = null) {
    const params = {}
    const queryParams = { parentId: parentId }

    if (String(name) !== '') {
      queryParams.name = name

      delete queryParams.parentId
    }

    params.params = queryParams

    if (cancelTokenSource) {
      params.cancelToken = cancelTokenSource.token
    }

    return HttpClient.api.get('/organizations', params)
  },
  /**
   * @param {IdType} organizationId
   * @param {CancelToken} [cancelTokenSource=null]
   * @returns {Promise}
   */
  Get (organizationId, cancelTokenSource = null) {
    const params = {}
    if (cancelTokenSource) {
      params.cancelToken = cancelTokenSource.token
    }

    return HttpClient.api.get(`/organizations/${organizationId}`, params)
  },
  /**
   * @param {Organization}
   * @returns {Promise}
   */
  Post (organization) {
    return HttpClient.api.post(`/organizations`, organization)
  },
  /**
   * @param {Organization}
   * @returns {Promise}
   */
  Put (organization) {
    return HttpClient.api.put(`/organizations/${organization.id}`, organization)
  },
  /**
   * @param {Organization}
   * @returns {Promise}
   */
  Delete (organization) {
    return HttpClient.api.delete(`/organizations/${organization.id}`, organization)
  }
}



// WEBPACK FOOTER //
// ./src/common/services/organization.js